import { render, staticRenderFns } from "./ed-split-vertical.vue?vue&type=template&id=6a823ecd&scoped=true&"
import script from "./ed-split-vertical.ts?vue&type=script&lang=ts&"
export * from "./ed-split-vertical.ts?vue&type=script&lang=ts&"
import style0 from "./ed-split-vertical.scss?vue&type=style&index=0&id=6a823ecd&lang=scss&scoped=true&"
import style1 from "../../styles/split-objects.scss?vue&type=style&index=1&id=6a823ecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a823ecd",
  null
  
)

export default component.exports